import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ jc: "center", ai: "center" })}
  gap: 3px;
  align-self: stretch;
`;

export const StyledRectangleContainer = styled(Box)`
  ${flex({ fd: "column", ai: "flex-start" })};
  width: 37px;
  height: 26px;
  flex: 1 0 0;
  border-radius: 2px;
  background-color: #95cde7;
`;
